module.exports = __webpack_public_path__ + "assets/img/mai.c64f30a2.jpg";